import React, { useEffect, useState } from "react";
import Table from "../Table/Table";
import { toast } from "react-toastify";
import Table_Buttons from "../Table_Button/Table_button";
import { API } from "../../Redux/actions/API";
import Navbar from "../Navbar/Navbar";
import { wait } from "@testing-library/user-event/dist/utils";
import {
  Abi_USDT,
  ContractAddress_USDT,
  contractAddressToken,
  abiToken,
} from "../../abi";
import { loadWeb3 } from "../../WalletConectivity/walletConnection";
import Spinner from "../Spinner/Spinner";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import { updateAuth } from "../../Redux/actions/AdminAuthSlice";

function Withdrawal_Pending_List() {
  const { userId, jwt_token } = useSelector((state) => state.Auth);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [currentPage, setcurrentPage] = useState(1);
  const [listPerpage, setlistPerpage] = useState(10);
  const [leftreferralApi, setleftreferralApi] = useState([]);
  const [Rank, setRank] = useState(0);
  const [account, setAccount] = useState("");

  const [dataOutput, setdataOutput] = useState([]);
  const [connected, setconnected] = useState(
    "Wallet is not connected..!..Wait..."
  );

  const [name, setname] = useState("");
  const [spinner, setSpinner] = useState(false);
  const [Uid, setUid] = useState("");
  const [uplineId, setuplineId] = useState("");
  const [fdate, setfdate] = useState("");
  const [isChecked, setIsChecked] = useState([]);
  const [isAllChecked, setIsAllChecked] = useState(false);
  // console.log("Select All:", isAllChecked, "Checked IDs:", isChecked);

  const handleCheckboxChange = (event, isSelectAll = false) => {
    if (isSelectAll) {
      const allIds = leftreferralApi.map((item) => Number(item.id));

      if (isAllChecked) {
        setIsChecked([]);
        setIsAllChecked(false);
      } else {
        setIsChecked(allIds);
        setIsAllChecked(true);
      }
    } else {
      const value = Number(event.target.value);

      if (event.target.checked) {
        setIsChecked((prev) => [...prev, value]);
      } else {
        setIsChecked((prev) => prev.filter((id) => id !== value));
        setIsAllChecked(false);
      }
    }
  };

  // const handleChange = (event) => {
  //   const value = event.target.value;
  //   if (event.target.checked) {
  //     setIsChecked((prev) => [...prev, Number(value)]);
  //   } else {
  //     setIsChecked((prev) => prev.filter((id) => id !== value));
  //   }
  //   console.log("Updated isChecked:", isChecked);
  // };

  // const handleSelectAll = () => {
  //   if (isAllChecked) {
  //     setIsChecked([]);
  //     setIsAllChecked(false);
  //   } else {
  //     console.log("allIdsLeft", leftreferralApi);

  //     const allIds = leftreferralApi.map((item) => Number(item.id));
  //     console.log("allIds", allIds);

  //     setIsChecked(allIds);
  //     setIsAllChecked(true);
  //   }
  // };

  const referral_API = async () => {
    try {
      let response = await API?.post(
        "/PendingWithdrawal",
        {
          loginid: userId,
          uid: Uid.slice(2),
          uplineid: uplineId.slice(2),
          fdate: fdate,
          wtype: "USDT",
          name: name,
        },
        {
          headers: {
            Authorization: jwt_token,
          },
        }
      );

      setdataOutput(response?.data.dataOut);
      let responseData = response?.data?.data[0];
      let formattedData = responseData.map((item, index) => ({
        sr: index + 1,
        id: item.id,
        uid: `AC${item.uid}`,
        address: item.wallet,
        requestAmount: item.Request_amount,
        adminCharge: item.admincharge,
        Wtype: item.Wtype,
        date: item.req_date,
        paidamount: item.paidamount,
        f_name: item.f_name,
        mobile: item.mobile,
        email: item.email,
        TokenStatus:
          item.TokenStatus === 0 ? (
            <button
              className="btn btn-info btn-lg"
              style={{ width: "70px", borderRadius: "13px" }}
              onClick={() =>
                PayReward(item.id, item.tokenvalue, item.uid, item.wallet, 4)
              }
            >
              Pay
            </button>
          ) : (
            "Token Paid"
          ),
        BNBvalue: item.BNBvalue,
        status: item.status,
        UsdtStatus:
          item.UsdtStatus === 0 ? (
            <button
              className="btn btn-info btn-lg"
              style={{ width: "70px", borderRadius: "13px" }}
              onClick={() =>
                PayReward(item.id, item.paidamount, item.uid, item.wallet, 5)
              }
            >
              Pay
            </button>
          ) : (
            "USDT Paid"
          ),
        PaidManual: (
          <button
            className="btn btn-info btn-lg"
            style={{ width: "70px", borderRadius: "13px" }}
            onClick={() =>
              PayReward(item.id, item.Request_amount, item.uid, item.wallet, 2)
            }
          >
            Pay
          </button>
        ),
        Cancel: (
          <button
            className="btn btn-info btn-lg"
            style={{ width: "70px", borderRadius: "13px" }}
            onClick={() =>
              PayReward(item.id, item.Request_amount, item.uid, item.wallet, 3)
            }
          >
            Cancel
          </button>
        ),
        // checkedValue: (
        //   <input
        //     type="checkbox"
        //     value={item.id}
        //     checked={isChecked.includes(Number(item.id))}
        //     onChange={(e) => handleCheckboxChange(e)}
        //   />
        // ),
      }));

      setleftreferralApi(formattedData);
    } catch (e) {
      console.error("Error in referral_API:", e);
      if (
        e.response?.data?.showableMessage ===
        "Please login to access this resource"
      ) {
        dispatch(updateAuth({ AdminAuth: false, jwt_token: "", userId: null }));
        sessionStorage.clear();
        localStorage.clear();
        navigate("/");
      }
    }
  };

  const manualpay = async (type) => {
    if (isChecked.length === 0) {
      toast.error("No rows selected");
      return;
    }

    try {
      if (type === 6) {
        const response = await API.post(
          "/PaidWithdrawal",
          {
            loginid: userId,
            uid: 0,
            id: String(isChecked),
            txn: "Manually Paid",
            status: 1,
          },
          {
            headers: {
              Authorization: jwt_token,
            },
          }
        );

        // console.log("approve_api", response.data.data);
        toast.success(response.data.data);
        // window.location.reload();
        referral_API();
      } else if (type === 7) {
        const response = await API.post(
          "/PaidWithdrawal",
          {
            loginid: userId,
            uid: 0,
            id: String(isChecked),
            txn: "Cancelled by admin",
            status: 2,
          },
          {
            headers: {
              Authorization: jwt_token,
            },
          }
        );
        toast.success("withdrawal cancel");
        // console.log("approve_api", response.data.data);
        // toast.success(response.data.data);
        // window.location.reload();
        referral_API();
      }
    } catch (error) {
      console.error("Error while calling API:", error);
    }
  };

  const PayReward = async (RowId, Amount, Uid, WalletAddress, type) => {
    try {
      setSpinner(true);
      if (type === 2) {
        let res = await API.post(
          "/PaidWithdrawal",
          {
            loginid: userId,
            uid: 0,
            id: RowId,
            txn: "Manually Paid",
            status: 1,
          },
          {
            headers: {
              Authorization: jwt_token,
            },
          }
        );
        console.log("approve_api", res.data.data);
        toast.success(res.data.data.result);
        // window.location.reload();
        referral_API();
      } else if (type === 3) {
        let res = await API.post(
          "/PaidWithdrawal",
          {
            loginid: userId,
            uid: Uid,
            id: RowId,
            txn: "Cancel By Admin",
            status: 2,
          },
          {
            headers: {
              Authorization: jwt_token,
            },
          }
        );
        console.log("approve_api", res.data.data);
        toast.success("withdrawal cancel");
        // window.location.reload();
        referral_API();
      } else if (type === 4 || type === 5) {
        if (!WalletAddress) {
          toast.error("Wrong Wallet Address !!!");
          return;
        }

        bnbWalletConnection();

        let acc = await loadWeb3();
        if (acc === "No Wallet") {
          toast.error("No Wallet");
        } else if (acc === "Wrong Network") {
          toast.error("Wrong Network Please Connect Metamask Network");
        } else {
          // const gasPrice = await window.web3.eth.getGasPrice();

          let contract;
          const amountvalue = Amount.toString();
          let WithdawlAmount;
          if (type === 4) {
            contract = await new window.web3.eth.Contract(
              abiToken,
              contractAddressToken
            );
            WithdawlAmount = amountvalue * 10 ** 9;
            // console.log("WithdawlAmount-->", WithdawlAmount);
          } else {
            contract = await new window.web3.eth.Contract(
              Abi_USDT,
              ContractAddress_USDT
            );
            WithdawlAmount = window.web3.utils.toWei(amountvalue);
          }

          let trxResult = await contract.methods
            .transfer(WalletAddress, WithdawlAmount.toString())
            .send({
              from: acc,
            });
          console.log("trxResult", trxResult);
          trxResult = trxResult.transactionHash;

          console.log("Hash-->", trxResult, Uid, RowId, type);
          if (
            trxResult !== "" ||
            trxResult !== undefined ||
            trxResult !== null
          ) {
            let res = await API.post(
              "/PaidWithdrawal",
              {
                loginid: userId,
                uid: Uid,
                id: RowId,
                txn: trxResult,
                type: type,
                status: 1,
              },
              {
                headers: {
                  Authorization: jwt_token,
                },
              }
            );
            toast.success(res.data.data.result);
            // window.location.reload();
            referral_API();
          }
        }
      }
    } catch (error) {
      console.log("API ERROR", error);
      setSpinner(false);
    }
  };

  const bnbWalletConnection = async () => {
    try {
      let acc = await loadWeb3();
      setAccount(acc);
      if (acc == "No Wallet") {
        toast.error("No Wallet");
        setconnected("Wallet is locked");
      } else if (acc == "Wrong Network") {
        toast.error(" Wrong Network Please Connect Metamask Network");
        setconnected("Wallet is locked");
      } else {
        // setaddress(acc)
        console.log("Metamask Address", acc);
        setconnected("Wallet is Connected");
      }
    } catch (e) {
      console.log("Error While WalletConnect", e);
    }
  };

  useEffect(() => {
    referral_API();
  }, [spinner, isChecked]);

  const referral_API_Export = async () => {
    try {
      let responceRight = await API?.post(
        "/PendingWithdrawal",
        {
          loginid: userId,
          uid: Uid.slice(2),
          uplineid: uplineId.slice(2),
          fdate: fdate,
          wtype: "USDT",
        },
        {
          headers: {
            Authorization: jwt_token,
          },
        }
      );

      responceRight = responceRight?.data?.data[0];

      let arrayLeft = [];
      responceRight.forEach((item, index) => {
        arrayLeft.push({
          SrNo: index + 1,
          UserId: `AC${item.uid}`,
          Name: item.f_name,
          Mobile: item.mobile,
          Email: item.email,
          walletAddress: item.wallet,
          RequestAmount: item.Request_amount,
          AdminCharge: item.admincharge,
          PaidAmount: item.paidamount,
          RequestDate: item.req_date,
          Wtype: item.Wtype,
          Status: item.Status === 0 ? "Pending" : "USDT Paid",
        });
      });

      const fileName = "PendingWithdrawal";
      const fileType =
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
      const fileExtension = ".xlsx";
      const ws = XLSX.utils.json_to_sheet(arrayLeft);
      const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
      const excelBuffer = XLSX.write(wb, {
        bookType: "xlsx",
        type: "array",
      });
      const data = new Blob([excelBuffer], { type: fileType });
      FileSaver.saveAs(data, fileName + fileExtension);
    } catch (e) {
      console.log("Error While calling Myteam API", e);
    }
  };

  const indexOfLastPost = currentPage * listPerpage;
  const indexOfFirstPage = indexOfLastPost - listPerpage;
  const currentPostleft = leftreferralApi.slice(
    indexOfFirstPage,
    indexOfLastPost
  );

  var [my_team] = new useState({
    cols: [
      // {
      //   Header: "Bulk Select",
      //   accessor: "checkedValue",
      // },
      { Header: "S.No.", accessor: "sr" },
      { Header: "User Id", accessor: "uid" },
      { Header: "Name", accessor: "f_name" },
      { Header: "Mobile No", accessor: "mobile" },
      { Header: "Email", accessor: "email" },
      { Header: "Wallet Address", accessor: "address" },
      // { Header: "Rank", accessor: "RewardRank" },
      { Header: "Req. Amount", accessor: "requestAmount" },
      { Header: "Admin Charge", accessor: "adminCharge" },
      // { Header: "Game Fees($)", accessor: "Tds" },
      // { Header: "Net USDT", accessor: "amountusd" },
      // { Header: "Net Token", accessor: "tokenvalue1" },
      // { Header: "Total Invest.", accessor: "TotalInvestment" },
      // { Header: "Total Income", accessor: "totalIncome" },
      { Header: "Pay withd. Amount", accessor: "paidamount" },
      { Header: "Req. Date", accessor: "date" },
      // { Header: "Req.t Token", accessor: "tokenvalue" },
      { Header: "USDT Contact Paid", accessor: "UsdtStatus" },
      { Header: "Withs. Type", accessor: "Wtype" },
      { Header: "Status", accessor: "status" },
      { Header: "Manual Paid", accessor: "PaidManual" },
      { Header: "Cancel", accessor: "Cancel" },
    ],
  });

  return (
    <div>
      <Navbar />
      <div className="content-page">
        <div className="content">
          <div className="row">
            <div className="col-md-12">
              <div className="panel panel-primary">
                <div className="panel-heading">
                  <h4 className="panel-title">
                    USDT Pending Withdrawal Report{" "}
                  </h4>
                </div>
                <div className="panel-body">
                  <div
                    className="row"
                    style={{ marginTop: "-35px", marginBottom: "5px" }}
                  >
                    <div className="col-md-2">
                      <input
                        type="text"
                        id="txtuid"
                        value={Uid}
                        onChange={(e) => setUid(e.target.value)}
                        className="form-control ng-pristine ng-untouched ng-valid ng-empty ng-valid-maxlength"
                        placeholder="Enter UserId"
                        maxLength={10}
                      />
                    </div>
                    <div className="col-md-2">
                      <input
                        type="text"
                        id="txtuid"
                        value={uplineId}
                        onChange={(e) => setuplineId(e.target.value)}
                        className="form-control ng-pristine ng-untouched ng-valid ng-empty ng-valid-maxlength"
                        placeholder="Enter Upline Id"
                        maxLength={10}
                      />
                    </div>
                    <div className="col-md-2">
                      <input
                        className="form-control in-ip-1"
                        onChange={(e) => setfdate(e.target.value)}
                        id="fdate"
                        name="fdate"
                        type="date"
                      />
                    </div>
                    <div class="col-md-2">
                      <input
                        class="form-control in-ip-1"
                        id="name"
                        onChange={(e) => setname(e.target.value)}
                        name="name"
                        placeholder="Search By Name,email,mobile"
                        type="text"
                        value={name}
                      />
                    </div>
                    {/* <div class="col-md-2">
                      <select
                        name="Position"
                        className="form-control"
                        onChange={(e) => setRank(e.target.value)}
                      >
                        <option>Select Rank</option>
                        <option value="1">Basic</option>
                        <option value="2">1 STAR</option>
                        <option value="3">2 STAR</option>
                        <option value="4">3 STAR</option>
                        <option value="5">4 STAR</option>
                        <option value="6">5 STAR</option>
                        <option value="7">6 STAR</option>
                        <option value="8">7 STAR</option>
                      </select>
                    </div> */}
                    <div className="col-md-2">
                      <input
                        type="button"
                        id="btnsearch"
                        onClick={() => {
                          referral_API();
                        }}
                        className="btn btn-sm btn-primary"
                        value="Search"
                      />
                    </div>{" "}
                    <div className="col-md-2">
                      <input
                        type="button"
                        id="btnsearch"
                        onClick={() => {
                          referral_API_Export();
                        }}
                        className="btn btn-sm btn-primary"
                        value="Export to Excel"
                      />
                    </div>
                  </div>

                  <div className="row mt-2 ">
                    <div className="col-md-6 text-center">
                      <input
                        type="reset"
                        onClick={() => bnbWalletConnection()}
                        className="btn btn-md btn-success"
                        value="Connect Wallet"
                      />
                    </div>
                    <div className="col-md-6">
                      <span> Connected Wallet : {account}</span>
                    </div>
                  </div>
                  <div className="row mt-4 mb-4">
                    <div className="col-md-6 text-center ">
                      <p>
                        Total Requested Amount (USDT) : {dataOutput?.TotalUsd}
                        <br />
                        Total Withdrawal (USDT) :{
                          dataOutput?.TotalWithdrawlUsd
                        }{" "}
                      </p>
                    </div>
                    {/* <div className="col-md-6 text-center">
                      <p>
                        Total Paid Amount (Token 30%) : {dataOutput?.TotalToken}
                        <br /> Total Withdrawal (USDT 70%) :{" "}
                        {dataOutput?.TotalWithdrawlUsdt}{" "}
                      </p>
                    </div> */}
                  </div>
                  {/* <div className="row mt-2 ">
                    <div className="col-md-4">
                      <input
                        type="button"
                        id="btnselect"
                        className="btn btn-md btn-primary"
                        value={isAllChecked ? "UnSelect All" : " Select All"}
                        onClick={(e) => handleCheckboxChange(e, true)}
                      />
                    </div>
                    <div className="col-md-4">
                      <input
                        type="button"
                        id="btnsearch"
                        onClick={() => manualpay(6)}
                        className="btn btn-md btn-primary"
                        value="Bulk Manual Pay"
                      />
                    </div>
                    <div className="col-md-4">
                      <input
                        type="button"
                        id="btnsearch"
                        onClick={() => manualpay(7)}
                        className="btn btn-md btn-danger"
                        value="Bulk Manual Cancel"
                      />
                    </div>
                  </div> */}

                  <div className="col-md-12">
                    <Table data={currentPostleft} columns={my_team.cols} />

                    <Table_Buttons
                      indexOfFirstPage={indexOfFirstPage}
                      indexOfLastPost={indexOfLastPost}
                      setcurrentPage={setcurrentPage}
                      currentPage={currentPage}
                      totalData={leftreferralApi.length}
                      listPerpage={listPerpage}
                      handleRowsPerPageChange={setlistPerpage}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Withdrawal_Pending_List;
